module.exports = __webpack_public_path__ + "static/media/wcru-untb.c4cf6fec.png";